var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-loader-container"},[_c('div',{staticClass:"step-loader-container--inner",style:({
      transform: `translateX(${-100 * _vm.activeComponentIndex}%)`
    })},_vm._l((_vm.vnodes),function(vnode,key){return _c('div',{key:key,staticClass:"step-item",class:{ 'step-item--active': _vm.activeComponentIndex === key }},[_c('v-node',{attrs:{"vnode":vnode}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }